import React from 'react';
import I18n from 'i18n-js';

import Earnings from './Earnings';
import WalletBalance from './WalletBalance';
import PayoutMethod from './PayoutMethod';
import { MONTHS_3 } from '../../shop_stats/time_periods';

export default function Overview(props) {
  const [timePeriod, setTimePeriod] = React.useState(MONTHS_3);

  return (
    <div className="earnings-payouts__overview">
      <div className="earnings-payouts__overview__title">
        {I18n.t('earnings.payouts.overview.title')}
      </div>
      <div className="earnings-payouts__overview__contents">
        <div className="earnings-payouts__overview__contents__row">
          <Earnings
            timePeriod={timePeriod}
            setTimePeriod={setTimePeriod}
          />
          <PayoutMethod {...props} />
        </div>
        <div className="earnings-payouts__overview__contents__row">
          <WalletBalance />
          {props.children}
        </div>
      </div>
    </div>
  );
}
